"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
require("@/components/common");
let PortfolioItem = class PortfolioItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.layout = 'grid';
        this.label = '';
        this.description = '';
        this.src = '';
        this.alt = '';
        this.badge = '';
        this.datetime = '';
        this.ariaExpanded = null;
        this.ariaHasPopup = null;
        this.ariaControls = null;
        this.keywords = [];
    }
    render() {
        return (0, lit_1.html) `
      <article
        role=${this.ariaControls ? 'button' : 'article'}
        tabindex=${this.ariaControls ? '0' : '-1'}
        aria-expanded=${(0, if_defined_js_1.ifDefined)(this.ariaExpanded ?? undefined)}
        aria-haspopup=${(0, if_defined_js_1.ifDefined)(this.ariaHasPopup ?? undefined)}
        aria-controls=${(0, if_defined_js_1.ifDefined)(this.ariaControls ?? undefined)}
        @keydown=${this.handleKeyDown}
      >
        ${this.renderBadge()}
        <mm-more-button class="action"></mm-more-button>
        ${this.renderThumbnail()}
        <div class="content">
          ${this.renderHeading()} ${this.renderDescription()} ${this.renderDatetime()}
          ${this.renderKeywords()}
          <slot></slot>
        </div>
      </article>
    `;
    }
    renderBadge() {
        if (!this.badge)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-accent-tag class="badge">${this.badge}</mm-accent-tag>
    `;
    }
    renderThumbnail() {
        if (!this.src)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-thumbnail src=${this.src} alt=${this.alt}></mm-thumbnail>
    `;
    }
    renderHeading() {
        if (!this.label)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-heading level="3">${this.label}</mm-heading>
    `;
    }
    renderDescription() {
        if (!this.description)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-paragraph>${this.description}</mm-paragraph>
    `;
    }
    renderDatetime() {
        if (!this.datetime)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <time hidden datetime=${this.datetime}>${this.formattedDatetime}</time>
    `;
    }
    renderKeywords() {
        if (!this.keywords.length)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-keyword-tag-group class="keyword-tags" .keywords=${this.keywords}></mm-keyword-tag-group>
    `;
    }
    // 클릭은 호스트까지 올라가 aria-controls가 가리키는 표면이 받는다. 키보드는 네이티브 button처럼 클릭으로 바꿔 보낸다.
    handleKeyDown(event) {
        if (!this.ariaControls)
            return;
        if (event.key !== 'Enter' && event.key !== ' ')
            return;
        event.preventDefault();
        event.currentTarget.click();
    }
    get formattedDatetime() {
        if (!this.datetime)
            return '';
        return this.datetime.replaceAll('-', '. ');
    }
};
PortfolioItem.styles = (0, lit_1.css) `
    :host {
      display: flex;
      width: 100%;
      cursor: pointer;
    }

    article {
      --lift: none;

      display: flex;
      flex-direction: column;
      width: 100%;
      gap: var(--space-3);
      position: relative;
      transform: var(--lift);
      transition: transform var(--transition-duration) var(--transition-easing);
    }

    ${shared_styles_1.interactiveElement}:hover {
      --lift: var(--interaction-hover-lift);
    }

    ${shared_styles_1.interactiveElement}:focus-visible {
      ${shared_styles_1.focusRingStyles};
    }

    .badge,
    .action {
      position: absolute;
      z-index: var(--material-zindex-elevated);
    }

    .badge {
      top: calc(var(--space-1) * -1);
      left: calc(var(--space-1) * -1);
    }

    .action {
      top: var(--space-2);
      right: var(--space-2);
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: var(--space-1);
    }

    .keyword-tags {
      margin-top: var(--space-2);
    }

    time {
      color: var(--foreground-subtle-color);
      font-size: var(--font-size-12);
      line-height: var(--font-size-12);
    }

    :host([layout='list']) article {
      flex-direction: row;
    }

    :host([layout='list']) mm-thumbnail {
      width: 156px;
      flex: none;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], PortfolioItem.prototype, "layout", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PortfolioItem.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PortfolioItem.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PortfolioItem.prototype, "src", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PortfolioItem.prototype, "alt", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PortfolioItem.prototype, "badge", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PortfolioItem.prototype, "datetime", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-expanded' })
], PortfolioItem.prototype, "ariaExpanded", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-haspopup' })
], PortfolioItem.prototype, "ariaHasPopup", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-controls' })
], PortfolioItem.prototype, "ariaControls", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], PortfolioItem.prototype, "keywords", void 0);
PortfolioItem = __decorate([
    (0, decorators_js_1.customElement)('mm-portfolio-item')
], PortfolioItem);
exports.PortfolioItem = PortfolioItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9ydGZvbGlvLWl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwb3J0Zm9saW8taXRlbS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBb0Q7QUFDcEQscURBQTJEO0FBQzNELGdFQUF3RDtBQUl4RCwrREFBaUY7QUFDakYsK0JBQTRCO0FBS3JCLElBQU0sYUFBYSxHQUFuQixNQUFNLGFBQWMsU0FBUSxnQkFBVTtJQUF0Qzs7UUFxRXNDLFdBQU0sR0FBd0IsTUFBTSxDQUFBO1FBQ25ELFVBQUssR0FBRyxFQUFFLENBQUE7UUFDVixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUNoQixRQUFHLEdBQUcsRUFBRSxDQUFBO1FBQ1IsUUFBRyxHQUFHLEVBQUUsQ0FBQTtRQUNSLFVBQUssR0FBRyxFQUFFLENBQUE7UUFDVixhQUFRLEdBQUcsRUFBRSxDQUFBO1FBQ2UsaUJBQVksR0FBZ0IsSUFBSSxDQUFBO1FBQ2hDLGlCQUFZLEdBQWlCLElBQUksQ0FBQTtRQUNqQyxpQkFBWSxHQUFjLElBQUksQ0FBQTtRQUN0RCxhQUFRLEdBQWEsRUFBRSxDQUFBO0lBcUZ6RCxDQUFDO0lBbkZDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztlQUVBLElBQUksQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsU0FBUzttQkFDcEMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJO3dCQUN6QixJQUFBLHlCQUFTLEVBQUMsSUFBSSxDQUFDLFlBQVksSUFBSSxTQUFTLENBQUM7d0JBQ3pDLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsWUFBWSxJQUFJLFNBQVMsQ0FBQzt3QkFDekMsSUFBQSx5QkFBUyxFQUFDLElBQUksQ0FBQyxZQUFZLElBQUksU0FBUyxDQUFDO21CQUM5QyxJQUFJLENBQUMsYUFBYTs7VUFFM0IsSUFBSSxDQUFDLFdBQVcsRUFBRTs7VUFFbEIsSUFBSSxDQUFDLGVBQWUsRUFBRTs7WUFFcEIsSUFBSSxDQUFDLGFBQWEsRUFBRSxJQUFJLElBQUksQ0FBQyxpQkFBaUIsRUFBRSxJQUFJLElBQUksQ0FBQyxjQUFjLEVBQUU7WUFDekUsSUFBSSxDQUFDLGNBQWMsRUFBRTs7OztLQUk1QixDQUFBO0lBQ0gsQ0FBQztJQUVPLFdBQVc7UUFDakIsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFL0IsT0FBTyxJQUFBLFVBQUksRUFBQTtxQ0FDc0IsSUFBSSxDQUFDLEtBQUs7S0FDMUMsQ0FBQTtJQUNILENBQUM7SUFFTyxlQUFlO1FBQ3JCLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRztZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRTdCLE9BQU8sSUFBQSxVQUFJLEVBQUE7MEJBQ1csSUFBSSxDQUFDLEdBQUcsUUFBUSxJQUFJLENBQUMsR0FBRztLQUM3QyxDQUFBO0lBQ0gsQ0FBQztJQUVPLGFBQWE7UUFDbkIsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFL0IsT0FBTyxJQUFBLFVBQUksRUFBQTs4QkFDZSxJQUFJLENBQUMsS0FBSztLQUNuQyxDQUFBO0lBQ0gsQ0FBQztJQUVPLGlCQUFpQjtRQUN2QixJQUFJLENBQUMsSUFBSSxDQUFDLFdBQVc7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVyQyxPQUFPLElBQUEsVUFBSSxFQUFBO3NCQUNPLElBQUksQ0FBQyxXQUFXO0tBQ2pDLENBQUE7SUFDSCxDQUFDO0lBRU8sY0FBYztRQUNwQixJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVE7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVsQyxPQUFPLElBQUEsVUFBSSxFQUFBOzhCQUNlLElBQUksQ0FBQyxRQUFRLElBQUksSUFBSSxDQUFDLGlCQUFpQjtLQUNoRSxDQUFBO0lBQ0gsQ0FBQztJQUVPLGNBQWM7UUFDcEIsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsTUFBTTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRXpDLE9BQU8sSUFBQSxVQUFJLEVBQUE7NkRBQzhDLElBQUksQ0FBQyxRQUFRO0tBQ3JFLENBQUE7SUFDSCxDQUFDO0lBRUQsNkVBQTZFO0lBQ3JFLGFBQWEsQ0FBQyxLQUFvQjtRQUN4QyxJQUFJLENBQUMsSUFBSSxDQUFDLFlBQVk7WUFBRSxPQUFNO1FBQzlCLElBQUksS0FBSyxDQUFDLEdBQUcsS0FBSyxPQUFPLElBQUksS0FBSyxDQUFDLEdBQUcsS0FBSyxHQUFHO1lBQUUsT0FBTTtRQUV0RCxLQUFLLENBQUMsY0FBYyxFQUFFLENBQ3JCO1FBQUMsS0FBSyxDQUFDLGFBQTZCLENBQUMsS0FBSyxFQUFFLENBQUE7SUFDL0MsQ0FBQztJQUVELElBQVksaUJBQWlCO1FBQzNCLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUTtZQUFFLE9BQU8sRUFBRSxDQUFBO1FBQzdCLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQyxVQUFVLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFBO0lBQzVDLENBQUM7O0FBbEtNLG9CQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUFtQmYsa0NBQWtCOzs7O01BSWxCLGtDQUFrQjtRQUNoQiwrQkFBZTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQTJDcEIsQ0FBQTtBQUMwQztJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzs2Q0FBcUM7QUFDbkQ7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzRDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2tEQUFpQjtBQUNoQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7MENBQVM7QUFDUjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7MENBQVM7QUFDUjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7NENBQVc7QUFDVjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7K0NBQWM7QUFDZTtJQUF2RCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxlQUFlLEVBQUUsQ0FBQzttREFBaUM7QUFDaEM7SUFBdkQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsZUFBZSxFQUFFLENBQUM7bURBQWtDO0FBQ2pDO0lBQXZELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLGVBQWUsRUFBRSxDQUFDO21EQUErQjtBQUN0RDtJQUEvQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLENBQUM7K0NBQXdCO0FBL0U1QyxhQUFhO0lBRHpCLElBQUEsNkJBQWEsRUFBQyxtQkFBbUIsQ0FBQztHQUN0QixhQUFhLENBb0t6QjtBQXBLWSxzQ0FBYSJ9